/**
 * Redline logo morph — old mark (disc + orbit) → new mark (split semicircles).
 * Plays once per browser session on first paint; then stays on the final mark.
 */
(function () {
  var RED = '#D32F2F';
  var WHITE = '#FFFFFF';
  var CX = 50;
  var CY = 50;
  var R_DOT = 28;
  var R_ORBIT = 38;
  var GAP = 2.6;
  var STROKE = 5.2;
  var ARC_SPAN = 0.80;
  var ARC_LEN = ARC_SPAN * R_ORBIT;
  var G = { x: CX + R_ORBIT, y: CY };
  var DISC_RIGHT = { x: CX + R_DOT, y: CY };
  var TIP_LEFT = { x: CX - R_DOT, y: CY };
  var SESSION_KEY = 'rl-logo-morph-played';
  var maskSeq = 0;

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function polar(r, ang) {
    return { x: CX + r * Math.cos(ang), y: CY + r * Math.sin(ang) };
  }

  function arcPath(r, a0, a1) {
    var p0 = polar(r, a0);
    var p1 = polar(r, a1);
    var delta = a1 - a0;
    var large = Math.abs(delta) > Math.PI ? 1 : 0;
    var sweep = delta >= 0 ? 1 : 0;
    return {
      d:
        'M ' +
        p0.x.toFixed(3) +
        ' ' +
        p0.y.toFixed(3) +
        ' A ' +
        r +
        ' ' +
        r +
        ' 0 ' +
        large +
        ' ' +
        sweep +
        ' ' +
        p1.x.toFixed(3) +
        ' ' +
        p1.y.toFixed(3),
    };
  }

  function orbitPath(tipAng) {
    return arcPath(R_ORBIT, tipAng - ARC_SPAN, tipAng).d;
  }

  function entryGeometry(u) {
    var e = Math.min(1, Math.max(0, u));
    var tipX = lerp(G.x, TIP_LEFT.x, e);
    var tip = { x: tipX, y: CY };
    var fed = G.x - tipX;
    var remainLen = Math.max(0, ARC_LEN - fed);
    var remainAng = remainLen / R_ORBIT;
    var ROUND = 7;
    var out = '';
    var inn = '';

    if (remainAng > 0.0008) {
      var redEndX = Math.max(tipX, DISC_RIGHT.x);
      var alpha = Math.min(remainAng * 0.5, ROUND / R_ORBIT);
      var ang = -alpha;
      var p = polar(R_ORBIT, ang);

      if (remainAng > alpha + 0.002) {
        out = arcPath(R_ORBIT, -remainAng, ang).d;
      } else {
        out = 'M ' + p.x.toFixed(3) + ' ' + p.y.toFixed(3);
      }

      if (redEndX < G.x - 0.001) {
        var qEndX = Math.max(redEndX, G.x - ROUND);
        out +=
          ' Q ' +
          G.x.toFixed(3) +
          ' ' +
          G.y.toFixed(3) +
          ' ' +
          qEndX.toFixed(3) +
          ' ' +
          CY;
        if (redEndX < qEndX - 0.001) {
          out += ' L ' + redEndX.toFixed(3) + ' ' + CY;
        }
      }
    } else {
      var rightEnd = tipX + ARC_LEN;
      if (rightEnd > DISC_RIGHT.x + 0.001) {
        var leftOfRed = Math.max(tipX, DISC_RIGHT.x);
        out =
          'M ' +
          rightEnd.toFixed(3) +
          ' ' +
          CY +
          ' L ' +
          leftOfRed.toFixed(3) +
          ' ' +
          CY;
      }
    }

    if (tipX < DISC_RIGHT.x - 0.001) {
      inn =
        'M ' +
        DISC_RIGHT.x.toFixed(3) +
        ' ' +
        CY +
        ' L ' +
        tipX.toFixed(3) +
        ' ' +
        CY;
    }

    return { out: out, inn: inn, tip: tip, e: e };
  }

  function describeHalf(which, gap) {
    var inset = gap / 2;
    var flatY = which === 'top' ? CY - inset : CY + inset;
    var halfW = Math.sqrt(Math.max(0, R_DOT * R_DOT - inset * inset));
    var x0 = CX - halfW;
    var x1 = CX + halfW;
    var cr = Math.min(2.2, halfW * 0.12);
    var dAng = cr / R_DOT;
    var angL = Math.atan2(flatY - CY, x0 - CX);
    var angR = Math.atan2(flatY - CY, x1 - CX);
    var startAng = which === 'top' ? angL + dAng : angL - dAng;
    var endAng = which === 'top' ? angR - dAng : angR + dAng;
    var pL = {
      x: CX + R_DOT * Math.cos(startAng),
      y: CY + R_DOT * Math.sin(startAng),
    };
    var pR = {
      x: CX + R_DOT * Math.cos(endAng),
      y: CY + R_DOT * Math.sin(endAng),
    };
    var sweepOuter = which === 'top' ? 0 : 1;

    return [
      'M ' + (x0 + cr).toFixed(3) + ' ' + flatY.toFixed(3),
      'L ' + (x1 - cr).toFixed(3) + ' ' + flatY.toFixed(3),
      'Q ' +
        x1.toFixed(3) +
        ' ' +
        flatY.toFixed(3) +
        ' ' +
        pR.x.toFixed(3) +
        ' ' +
        pR.y.toFixed(3),
      'A ' +
        R_DOT +
        ' ' +
        R_DOT +
        ' 0 0 ' +
        sweepOuter +
        ' ' +
        pL.x.toFixed(3) +
        ' ' +
        pL.y.toFixed(3),
      'Q ' +
        x0.toFixed(3) +
        ' ' +
        flatY.toFixed(3) +
        ' ' +
        (x0 + cr).toFixed(3) +
        ' ' +
        flatY.toFixed(3),
      'Z',
    ].join(' ');
  }

  function svgEl(root) {
    return root.ownerSVGElement || root.closest('svg');
  }

  function setStrokePair(root, geo) {
    var strokeOut = root.querySelector('.rl-stroke-out');
    var strokeIn = root.querySelector('.rl-stroke-in');
    if (!strokeOut || !strokeIn) return;

    if (geo.out) {
      strokeOut.setAttribute('d', geo.out);
      strokeOut.setAttribute('stroke', RED);
      strokeOut.style.display = '';
    } else {
      strokeOut.setAttribute('d', '');
      strokeOut.style.display = 'none';
    }

    if (geo.inn) {
      strokeIn.setAttribute('d', geo.inn);
      strokeIn.setAttribute('stroke', WHITE);
      strokeIn.setAttribute('stroke-width', String(GAP));
      strokeIn.style.display = '';
    } else {
      strokeIn.setAttribute('d', '');
      strokeIn.style.display = 'none';
    }
  }

  function setCutMask(root, tipX) {
    var punch = svgEl(root) && svgEl(root).querySelector('.rl-gap-punch');
    if (!punch) return;

    if (tipX >= DISC_RIGHT.x - 0.05) {
      punch.setAttribute('fill', '#fff');
      return;
    }

    var pad = 2;
    var left = tipX;
    var right = CX + R_DOT + pad;
    punch.setAttribute('fill', '#000');
    punch.setAttribute('x', String(left));
    punch.setAttribute('y', String(CY - GAP / 2));
    punch.setAttribute('width', String(Math.max(0.01, right - left)));
    punch.setAttribute('height', String(GAP));
    punch.setAttribute('rx', '0');
    punch.setAttribute('ry', '0');
  }

  function clearCutMask(root) {
    var punch = svgEl(root) && svgEl(root).querySelector('.rl-gap-punch');
    if (!punch) return;
    punch.setAttribute('fill', '#fff');
  }

  function setHalves(root) {
    var topP = root.querySelector('.rl-half-top');
    var botP = root.querySelector('.rl-half-bot');
    if (topP) topP.setAttribute('d', describeHalf('top', GAP));
    if (botP) botP.setAttribute('d', describeHalf('bottom', GAP));
  }

  function setSplit(root, on) {
    var disc = root.querySelector('.rl-disc');
    var halves = root.querySelector('.rl-halves');
    if (!disc || !halves) return;
    if (on) {
      setHalves(root);
      disc.style.display = 'none';
      halves.style.display = '';
      clearCutMask(root);
    } else {
      disc.style.display = '';
      halves.style.display = 'none';
      clearCutMask(root);
    }
  }

  function svgMarkup() {
    var mid = 'rl-gap-' + ++maskSeq;
    return (
      '<svg viewBox="0 0 100 100" fill="none" aria-hidden="true">' +
      '<defs>' +
      '<mask id="' +
      mid +
      '" maskUnits="userSpaceOnUse" x="0" y="0" width="100" height="100">' +
      '<rect width="100" height="100" fill="#fff" />' +
      '<rect class="rl-gap-punch" x="0" y="' +
      (CY - GAP / 2) +
      '" width="0" height="' +
      GAP +
      '" fill="#fff" />' +
      '</mask>' +
      '</defs>' +
      '<g class="rl-morph">' +
      '<circle class="rl-disc" cx="' +
      CX +
      '" cy="' +
      CY +
      '" r="' +
      R_DOT +
      '" fill="' +
      RED +
      '" mask="url(#' +
      mid +
      ')" />' +
      '<g class="rl-halves" style="display:none">' +
      '<path class="rl-half-top" d="' +
      describeHalf('top', GAP) +
      '" fill="' +
      RED +
      '" />' +
      '<path class="rl-half-bot" d="' +
      describeHalf('bottom', GAP) +
      '" fill="' +
      RED +
      '" />' +
      '</g>' +
      '<path class="rl-stroke-out" fill="none" stroke="' +
      RED +
      '" stroke-width="' +
      STROKE +
      '" stroke-linecap="round" stroke-linejoin="round" d="' +
      orbitPath(-Math.PI / 2) +
      '" />' +
      '<path class="rl-stroke-in" fill="none" stroke="' +
      WHITE +
      '" stroke-width="' +
      GAP +
      '" stroke-linecap="round" stroke-linejoin="round" d="" style="display:none" />' +
      '</g>' +
      '</svg>'
    );
  }

  function mount(el) {
    el.innerHTML = svgMarkup();
    return el.querySelector('.rl-morph');
  }

  function animateProp(duration, onUpdate) {
    return new Promise(function (resolve) {
      var t0 = performance.now();
      function frame(now) {
        var raw = Math.min(1, (now - t0) / duration);
        try {
          onUpdate(raw);
        } catch (err) {
          console.error(err);
          resolve();
          return;
        }
        if (raw < 1) requestAnimationFrame(frame);
        else resolve();
      }
      requestAnimationFrame(frame);
    });
  }

  function sessionPlayed() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markSessionPlayed() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {
      /* ignore */
    }
  }

  async function play(root, opts) {
    opts = opts || {};
    var skipToEnd = !!opts.skipToEnd;
    var strokeOut = root.querySelector('.rl-stroke-out');
    var strokeIn = root.querySelector('.rl-stroke-in');
    var token = (root._playToken = (root._playToken || 0) + 1);

    setSplit(root, false);
    strokeOut.style.display = '';
    strokeOut.setAttribute('stroke', RED);
    strokeOut.setAttribute('stroke-width', String(STROKE));
    strokeIn.style.display = 'none';
    strokeIn.setAttribute('stroke', WHITE);
    strokeIn.setAttribute('stroke-width', String(GAP));
    strokeIn.setAttribute('opacity', '1');
    strokeOut.setAttribute('d', orbitPath(-Math.PI / 2));

    if (
      skipToEnd ||
      (window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches)
    ) {
      setSplit(root, true);
      strokeOut.style.display = 'none';
      strokeIn.style.display = 'none';
      markSessionPlayed();
      return;
    }

    var ang0 = -Math.PI / 2;
    var travel = Math.PI * 2 + Math.PI / 2;
    var DUR = 4400;
    var ORBIT_END = 0.42;
    var ENTRY_END = 0.82;
    var splitOn = false;

    await animateProp(DUR, function (p) {
      if (root._playToken !== token) return;

      if (p < ORBIT_END) {
        var orbitP = p / ORBIT_END;
        strokeIn.style.display = 'none';
        strokeIn.setAttribute('d', '');
        strokeOut.style.display = '';
        strokeOut.setAttribute('d', orbitPath(ang0 + travel * orbitP));
        clearCutMask(root);
        return;
      }

      if (p < ENTRY_END) {
        var t = (p - ORBIT_END) / (ENTRY_END - ORBIT_END);
        var entryU = 1 - Math.pow(1 - t, 1.35);
        var geo = entryGeometry(entryU);
        setStrokePair(root, geo);
        setCutMask(root, geo.tip.x);
        return;
      }

      var geoEnd = entryGeometry(1);
      setStrokePair(root, geoEnd);
      setCutMask(root, TIP_LEFT.x);

      if (!splitOn) {
        splitOn = true;
        setSplit(root, true);
      }

      var tf = (p - ENTRY_END) / (1 - ENTRY_END);
      var s = 1 - Math.pow(1 - tf, 2.1);
      strokeIn.style.display = '';
      strokeIn.setAttribute('d', geoEnd.inn);
      strokeIn.setAttribute('stroke-width', String(GAP));
      strokeIn.setAttribute('opacity', String(Math.max(0, 1 - s)));
      if (s > 0.98) {
        strokeIn.style.display = 'none';
        strokeIn.setAttribute('opacity', '1');
      }
    });

    if (root._playToken !== token) return;

    strokeIn.style.display = 'none';
    strokeIn.setAttribute('opacity', '1');
    setStrokePair(root, { out: '', inn: '' });
    setSplit(root, true);
    markSessionPlayed();
  }

  function init() {
    var nodes = document.querySelectorAll('[data-rl-logo-morph]');
    if (!nodes.length) return;

    var skip = sessionPlayed();
    nodes.forEach(function (el) {
      var root = mount(el);
      play(root, { skipToEnd: skip });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
